<template>
  <div>
    <div class="filterbox">
      <!-- <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
        <span class="count_span1">浏览数：</span
        ><span class="count_span">{{ countRate.llcount }}</span>
        <span class="count_span1">对话率：</span
        ><span class="count_span">{{ countRate.diaRate }}</span>
        <span class="count_span1">对话数：</span
        ><span class="count_span">{{ countRate.ddcount }}</span>
        <span class="count_span1">转潜数：</span
        ><span class="count_span">{{ countRate.wxcount }}</span>
        <span class="count_span1">转潜率：</span
        ><span class="count_span">{{ countRate.wxRate }}</span>
      </div> -->
      <div class="filter-with-count" v-if="bardata">
        <el-tag
          disable-transitions
          v-for="(item, index) in bardata"
          :key="index"
          closable
          style="margin-right: 10px"
          @close="handleClose(item)"
          size="small"
          type="info"
        >
          <span>
            <span style="color: #bbb" v-if="item.ftn">{{ item.ftn }}:</span>
            {{
              item.value.length > 15
                ? item.value.substring(0, 15) + "..."
                : item.value
            }}
          </span>
        </el-tag>
        <div class="count">
          <slot name="tip">
            <b>
              <slot name="count"></slot>
            </b>
          </slot>
        </div>
        <div class="count">
          <slot name="curnum">
            <b>
              <slot name="curcount"></slot>
            </b>
          </slot>
        </div>
        <div class="count">
          <slot name="selectnum">
            <b>
              <slot name="selectcount"></slot>
            </b>
          </slot>
        </div>
      </div>
      <div>
        <slot></slot>
      </div>
    </div>
    <div style="position: relative" v-if="data">
      <el-table
        ref="eltable"
        v-loading="isloading"
        :data="data"
        style="width: 100%"
        :show-summary="summary"
        @selection-change="handleSelectChange"
        border
        :max-height="tableHeight"
        :header-cell-style="headerStyle"
        @row-dblclick="clickRow"
        :row-class-name="tableRowClassName"
        :row-style="rowClass"
        @row-contextmenu="clickRight"
      >
        <el-table-column
          type="selection"
          width="45"
          v-if="selection"
        ></el-table-column>
        <!-- :width="item.width" -->
        <template v-for="(item, index) in columnConfig">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="index"
            :width="columnWidth(item.prop)"
            show-overflow-tooltip
            :fixed="item.isFixed"
          >
            <template slot="header">
              <template v-if="item.filterConfig && item.filterConfig.type">
                <span
                  @click="headerClick($event, item)"
                  class="customize_filter"
                  :id="`${item.filterConfig.type}_${item.prop}`"
                  style="cursor: pointer; display: inline-block"
                >
                  <span style="padding-right: 3px">{{ item.label }}</span>
                  <i class="el-icon-caret-bottom" />
                </span>
              </template>
              <template v-else>
                <span class="customize_filter" style="display: inline-block">
                  <span style="padding-right: 3px">{{ item.label }}</span>
                </span>
              </template>
            </template>
            <template slot-scope="{ row }">
              <template v-if="item.type === 'List'">
                <span v-for="(obj, k) in row[item.prop]" :key="k">
                  <span v-if="obj.color.length === 0">{{ obj.name }} </span>
                  <span v-else :style="labelStyle(obj)">{{ obj.name }} </span>
                </span>
              </template>
              <template v-else>
                {{ row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </template>
        <!-- 具有菜单的按钮 -->
        <template v-if="actionConfig">
          <!-- 单个按键 -->
          <el-table-column
            :width="actionConfig.width"
            v-if="actionConfig.type === 'button'"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button size="mini" @click.stop="actionConfig.handler(scope)"
                >{{ actionConfig.label }}
              </el-button>
            </template>
          </el-table-column>
          <!-- 文字按键 -->
          <el-table-column
            :width="actionConfig.width"
            v-if="actionConfig.type === 'textbtn'"
            label="操作"
            fixed
          >
            <template slot-scope="scope">
              <span
                @click.stop="actionConfig.handler(scope)"
                style="cursor: pointer; color: #35b9ff"
                >{{ actionConfig.label }}</span
              >
            </template>
          </el-table-column>
          <!-- 自定义操作区域 -->
          <el-table-column
            v-if="actionConfig.type === 'customize' && actionConfig.component"
            :width="actionConfig.width"
            :label="actionConfig.label ? actionConfig.label : '操作'"
          >
            <template slot-scope="scope">
              <component
                :is="actionConfig.component"
                :row="scope.row"
                @commonHanlerBridge="commonHanlerBridge"
                @doactive="doactive"
                :handlers="actionConfig.handlers"
              ></component>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <!-- 注册的筛选器 -->
      <div v-clickoutside="allfilterHide">
        <template v-for="(item, key) in regfilters">
          <!-- 输入框选择器 -->
          <div
            :class="{ filterWrap: true, hideBg: item.hidebg }"
            v-show="filterAction[key]"
            :key="key"
            :style="item.position"
          >
            <div class="filterContainer">
              <component
                :key="key"
                :is="item.component"
                :data="item.data"
                :filterkey="item.filterkey"
                :listinfo="item.listinfo"
                :clmnFilter="searchConfig.clmnFilter"
                :refname="item.refname"
                :cdata="item.cdata"
                :myprops="item.myprops"
                :placeholderstr="item.myplaceholder"
                :unit="item.unit"
                :ftn="item.ftn"
                :customizedata="item.customizedata"
                @getFilterBridge="getFilterBridge"
              >
              </component>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="pagination" class="paginationWrap">
      <!-- <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="[10000]"
        :current-page.sync="pageConfig.curpage"
        @size-change="handleSizeChange"
        @current-change="clickpage"
        :total="pageConfig.pagenum"
      >
      </el-pagination> -->
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="10000"
        :current-page.sync="pageConfig.curpage"
        :page-sizes="[10000]"
        @size-change="handleSizeChange"
        @current-change="clickpage"
        :total="pageConfig.pagenum"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import editFilter from "./Filters/edit.vue";
import dateFilter from "./Filters/date.vue";
import cascaderFilter from "./Filters/cascader.vue";
import searchFilter from "./Filters/search.vue";
import radiosFilter from "./Filters/radio.vue";
import rangeFilter from "./Filters/range.vue";
import Bus from "./js/Bus.js";
import { getFilter, doDeleteFilter, initFilterData } from "./js/index.js";

// import $ from "jquery";
var myFilterComponts = {
  edit: editFilter,
  date: dateFilter,
  cascader: cascaderFilter,
  search: searchFilter,
  radio: radiosFilter,
  range: rangeFilter,
};

// 渲染出来后各种类型筛选器的数量 对应的filter的key
// 因为可能有多个一样类型的筛选器
var curFilterCount = {
  edit: 0,
  date: 0,
  cascader: 0,
  search: 0,
  radio: 0,
  range: 0,
};
var _regFilter = {};
var _filterAction = {};
// 存放当前显示的 filter数据 e--》filter的header  filter--》filter的对象映射
var _curFilter = "";
// var _filterbar = null;
var _regfilterarr = [];
// 页面可视区宽度
var windowX = window.innerWidth;

export default {
  name: "dg-table",
  // destroyed() {
  // 	initFilterData()
  // 	for (let k in curFilterCount) {
  // 		curFilterCount[k] = 0
  // 	}
  // 	_regFilter = {}
  // 	_filterAction = {}
  // 	_curFilter = ''
  // 	_filterbar = null
  // },
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selection: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    pageConfig: {
      type: Object,
      default: function () {
        return {
          pagenum: 1,
          curpage: 1,
        };
      },
    },
    filterInit: Array,
    rowClick: {
      type: Function,
      default: function () {
        return () => {};
      },
    },
    summary: {
      type: Boolean,
      default: false,
    },
    actionConfig: Object,
    actionCompoent: {
      validator: function (vm) {
        return vm._isVue ? vm._isVue : null;
      },
    },
    columnConfig: Array,
    isloading: {
      type: Boolean,
      default: false,
    },
    // countRate: Object,
    columnsList: Array,
    source: [String, Number],
    keyrange: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      t_headre: {
        props: ["item", "headerClick", "f_id"],
        render: function () {
          return (
            <span
              onClick={this.headerClick}
              class="customize_filter"
              id={this.f_id}
              style="cursor:pointer;display:inline-block"
            >
              <span style="padding-right:3px;"> {this.item.label} </span>{" "}
              <i class="el-icon-caret-bottom" />
            </span>
          );
        },
      },
      bardata: [],
      regfilters: {},
      filterAction: {},
      filtericon: {},
      searchConfig: {
        content: "",
        startTime: "",
        endTime: "",
        status: "",
        clmnFilter: {},
      },
      tableHeight: 600,
      index: -1,
    };
  },

  methods: {
    // 点击分页
    clickpage(val) {
      this.$emit("page-change", val);
    },

    headerStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return "text-align:center;color:#000000;";
      }
    },
    removeAllTags() {
      for(var i = 0; i < this.bardata.length; i ++ ){
        var tag = this.bardata[i];
        doDeleteFilter(tag);
      }
      this.bardata = [];
    },

    setSearchConfig(obj, itype) {
      if (itype === 1) {
        this.searchConfig.content = obj;
      } else if (itype === 2) {
        this.searchConfig.startTime = obj.startTime;
        this.searchConfig.endTime = obj.endTime;
      } else if (itype === 3) {
        this.searchConfig.status = obj;
      } else if (itype === 4) {
        this.searchConfig.clmnFilter = obj;
        console.log("dg-table.vue setSearchConfig obj:", obj);
      } else if (itype === 5) {
        // xxx
      }
    },

    labelStyle(item) {
      return {
        backgroundColor: "#" + item.color,
        color: "#FFFFFF",
        font: "8px",
        paddingLeft: "5px",
        paddingRight: "5px",
        marginRight: "5px",
        borderRadius: "6px",
      };
    },

    handleSizeChange(val) {
      this.$emit("size-change", val);
    },

    // 删除tag
    handleClose(tag) {
      this.bardata.splice(this.bardata.indexOf(tag), 1);
      doDeleteFilter(tag);
      this.$emit("delTag", tag);
    },
    getTime(UTCDateString, type = "Y-M-D") {
      if (!UTCDateString) {
        return "-";
      }

      function formatFunc(str) {
        return str > 9 ? str : "0" + str;
      }
      var date2 = new Date(UTCDateString);
      var year = date2.getFullYear();
      var mon = formatFunc(date2.getMonth() + 1);
      var day = formatFunc(date2.getDate());
      var hour = date2.getHours();
      hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes());
      var dateStr;
      if (type === "Y-M-D") dateStr = year + "." + mon + "." + day;
      else dateStr = year + "." + mon + "." + day + "   " + hour + ":" + min;
      return dateStr;
    },
    getText(val) {
      var attarr = val.cc.prop.split(".");
      var curobj = val.s;
      for (var i = 0; i < attarr.length; i++) {
        if (!curobj[attarr[i]] && curobj[attarr[i]] !== 0) {
          return "-";
        }
        curobj = curobj[attarr[i]];
      }
      if (val.cc.cb) {
        return val.cc.cb(curobj);
      }

      return curobj;
    },
    doactive(d) {
      this.$emit(d.func, d.args);
    },

    getFilterBridge(val) {
      console.log("val=====", val);
      if (val.type === "date") {
        let formatdata = getFilter(val);
        this.bardata = formatdata.showfilter;
        // this.$emit('filter-change', formatdata.dofilter)
        this.$emit("filter-date", val);
      } else {
        if (val.action === "2") {
          console.log("val.action 2");
        }
        if (val.action === "1" || val.action === "4") {
          this.$emit("filterOption", val);
          let formatdata = getFilter(val);
          this.bardata = formatdata.showfilter;
          // this.$emit('filter-change', formatdata.dofilter)
        } else if (val.action === "3") {
          this.$emit("order-change", val);
        }
      }
      this.allfilterHide("none");
    },

    // 函数通讯桥梁
    // func---》页面要执行的函数名字
    // data---》需要的数据
    commonHanlerBridge({ func, data }) {
      this.$emit(func, data);
    },
    renderTableHeader(column, ftype, config) {
      var filtertag = this.doRegFilters(ftype, config);
      return (
        <span
          onClick={this.headerClick}
          class="customize_filter"
          id={filtertag}
          style="cursor:pointer;display:inline-block"
        >
          <span style="padding-right:3px;"> {column.label} </span>{" "}
          <i class="el-icon-caret-bottom" />
        </span>
      );
    },
    // 注册筛选器
    // 根据已经注册的该类型的筛选器的个数来确定
    // 筛选器的标志
    // 成功注册后该类型的筛选器 +1
    doRegFilters(ftype, columconfig) {
      // 注册自定义筛选器
      if (!myFilterComponts[ftype])
        this.regCustomizeFilter(ftype, columconfig.filterConfig);
      // 设置filter标志
      var filtertag = `${ftype}_${columconfig.prop}`;
      if (_regfilterarr.indexOf(filtertag) !== -1) return;
      curFilterCount[ftype] += 1;
      const _filterConfig = columconfig.filterConfig;
      if (!_filterConfig) return;
      _regfilterarr.push(filtertag);
      // 解决vue在 以索引的情况赋值 页面不刷新的问题
      let configs = {
        component: myFilterComponts[ftype],
        show: false,
        position: {
          top: 0,
          left: 0,
        },
        refname: filtertag,
        data: _filterConfig.items,
        myprops: _filterConfig.props,
        cdata: _filterConfig.options,
        filterkey: _filterConfig.key,
        listinfo: _filterConfig.listinfo,
        myplaceholder: _filterConfig.placeholder,
        unit: _filterConfig.unit,
        ftn: _filterConfig.ftn,
        hidebg: _filterConfig.hidebg,
        customizedata: _filterConfig.customizedata,
      };
      this.$set(_regFilter, filtertag, configs);
      this.regfilters = _regFilter;
      this.filterAction = JSON.parse(JSON.stringify(_filterAction));
      return filtertag;
    },
    regCustomizeFilter(ftype, fconfig) {
      /*
					if (curFilterCount.hasOwnProperty(ftype)) {
						curFilterCount[ftype] = 0
					}*/
      const customizeFilter = {};
      customizeFilter[ftype] = fconfig.component;
      myFilterComponts = Object.assign({}, myFilterComponts, customizeFilter);
    },
    headerClick(e, obj) {
      // console.log('dg-table headerClick e = ', e)
      console.log("dg-table headerClick obj = ", obj);

      e.cancelBubble = true;
      const curfilterId = e.currentTarget.id;
      if (_filterAction[curfilterId]) {
        document.querySelector(`#${curfilterId} i`) &&
          document
            .querySelector(`#${curfilterId} i`)
            .setAttribute("class", "el-icon-caret-bottom");
      } else {
        document.querySelector(`#${curfilterId} i`) &&
          document
            .querySelector(`#${curfilterId} i`)
            .setAttribute("class", "el-icon-caret-top");

        if (obj.filterConfig.type !== "date") {
          this.getOptionRequest(obj);
        }
      }
      this.allfilterHide(curfilterId);
      // this.filterPosition(
      // 	e.currentTarget.parentElement.parentElement,
      // 	curfilterId
      // )
      this.filterPosition1(
        e.currentTarget.parentElement.parentElement,
        curfilterId,
        e
      );
      this.$set(_filterAction, curfilterId, !_filterAction[curfilterId]);
      this.filterAction = _filterAction;
      var type = curfilterId.split("_")[0];
      _curFilter = curfilterId;
      // _filterbar = e.currentTarget.parentElement.parentElement;
      if (type === "date" && _filterAction[_curFilter]) {
        Bus.$emit("OPEN_DGTABLE_DATE_FILTER", curfilterId);
      }
      if (type === "cascader" && _filterAction[_curFilter]) {
        Bus.$emit("OPEN_DGTABLE_CASCADER_FILTER", curfilterId);
      }
      if (type === "radio" && _filterAction[_curFilter]) {
        Bus.$emit("LOAD_DGTABLE_RADIO_DATA", curfilterId);
      }
    },

    async getOptionRequest(obj) {
      console.log("source===========:", this.source, obj);
      const showValueList = obj.showValueList === 1;
      Bus.$emit("LOAD_OPTION_DATA", null, true, null, showValueList);
      if (showValueList) {
        const dataObj = {
          columnName: obj.filterConfig.key,
          page: 1,
          size: 1000,
          keyword: this.searchConfig.content,
          startTime: this.searchConfig.startTime,
          endTime: this.searchConfig.endTime,
          customerStatus: this.searchConfig.status,
          columnsFilter: {},
          source: this.source,
          keyrange: this.keyrange,
        };

        var api = "/manager/reporttable/filter/column/data";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: dataObj,
        });
        if (response.resultCode === "10000") {
          // let res = response.data;
          // 转潜点、参与点、访问次数，访客发言，客服发言，机器人发言
          if (
            dataObj.columnName === "cs_talk_count" ||
            dataObj.columnName === "robot_talk_count" ||
            dataObj.columnName === "customer_talk_count" ||
            dataObj.columnName === "zhaunqian_point" ||
            dataObj.columnName === "participation_point" ||
            dataObj.columnName === "visits_count"
          ) {
            response.data.sort((a, b) => {
              return a - b;
            });
            // console.log(response.data);
          }
          if (obj.filterConfig.type === "range") {
            Bus.$emit(
              "LOAD_OPTION_DATA",
              response.data,
              false,
              obj.filterConfig.key,
              showValueList
            );
          }
        } else {
          this.$message.error(response.desc);
          Bus.$emit(
            "LOAD_OPTION_DATA",
            response.data,
            false,
            obj.filterConfig.key,
            showValueList
          );
        }
      }
    },

    handleSelectChange(val) {
      // 解决选择 页面重新渲染的问题
      // _regFilter = {}
      // _filterAction = {}
      // this.regfilters = _regFilter
      this.$emit("select-change", val);
    },

    filterPosition1(filterbar, filtertag, e) {
      // var offsetLeft = filterbar.offsetLeft
      var offsetHeight = filterbar.offsetHeight;

      var pageX = e.pageX;
      // console.log('dg-table filterPosition1 pageX = ', pageX)
      if (_regFilter[filtertag]) {
        console.log(_regFilter[filtertag]);
        this.$set(
          _regFilter[filtertag].position,
          "top",
          offsetHeight - 10 + "px"
        );
        var ele = document.getElementsByClassName("filterbox")[0].parentNode;
        var ele2 = document.getElementsByClassName("filter_div")[0];
        var newWindowX = windowX;
        console.log(newWindowX, ele2, ele);
        var disX = pageX - 200;
        if (pageX <= 200) {
          disX = 0;
        }
        if (pageX + 200 >= newWindowX - ele.offsetLeft) {
          disX = newWindowX - ele.offsetLeft * 2 - 320;
          console.log(newWindowX - ele.offsetLeft - 320);
        }

        this.$set(_regFilter[filtertag].position, "left", disX + "px");
      }
      this.regfilters = _regFilter;
      // console.log('dg-table filterPosition1 regfilters = ', this.regfilters)
    },

    filterPosition(filterbar, filtertag) {
      var offsetLeft = filterbar.offsetLeft;
      var offsetHeight = filterbar.offsetHeight;

      if (_regFilter[filtertag]) {
        this.$set(
          _regFilter[filtertag].position,
          "top",
          offsetHeight - 10 + "px"
        );
        this.$set(_regFilter[filtertag].position, "left", offsetLeft + "px");
      }
      this.regfilters = _regFilter;
    },
    allfilterHide(cfilter) {
      for (var k in _filterAction) {
        if (k !== cfilter) {
          this.$set(_filterAction, k, false);
          if (document.querySelector(`#${k} i`))
            document
              .querySelector(`#${k} i`)
              .setAttribute("class", "el-icon-caret-bottom");
        }
      }
      this.filterAction = _filterAction;
    },
    // 用于初始化 filters bar
    initFilterBar() {
      initFilterData({});
      let tags = [];
      this.bardata = tags;
      // 	let initfilters = this.tableInfo.toolsConfig.filters;
      // 	if (typeof initfilters === 'object' && typeof initfilters.length !== 'number') {
      // 		let tags = [];
      // 		initFilterData(initfilters);
      // 		for (let k in initfilters) {
      // 			tags.push(initfilters[k]);
      // 		}
      // 	this.bardata = tags;
      // }
    },
    // 右键点击菜单
    clickRight(row, column, event) {
      event.preventDefault();
      console.log("row, column, event", row, column, event);
      this.$emit("row-contextmenu", row);
    },
    clickRow(row) {
      // this.index = row.index
      // this.$refs.eltable.setCurrentRow(row)
      this.index = row.index;
      this.$emit("row-dblclick", row);
    },

    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    rowClass({ rowIndex }) {
      if (rowIndex == this.index) {
        return {
          "background-color": "rgba(185, 221, 249)",
        };
      }
    },

    // 宽度方法
    columnWidth(propItem) {
      for (let i = 0; i < this.columnsList.length; i++) {
        if (propItem == this.columnsList[i].columnId) {
          return this.columnsList[i].columnWidth;
        }
      }
    },
  },

  directives: {
    clickoutside: {
      bind: function (el, binding) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  mounted: function () {
    this.initFilterBar();
    this.columnConfig.forEach((e) => {
      if (e.filterConfig) {
        this.doRegFilters(e.filterConfig.type, e);
      }
    });
    window.onresize = () => {
      console.log(this._filterbar);
      // setTimeout(() => {
      //   if (_filterbar) this.filterPosition(_filterbar, _curFilter);
      // }, 0);
    };
    this.$nextTick(() => {
      // var seaH = $(".head_div").height() ? $(".head_div").height() : 0;
      // var countH = $(".count").height() ? $(".count").height() : 0;
      // this.tableHeight = window.innerHeight - seaH - countH - 300;
      var innerHeight = window.innerHeight;
      this.tableHeight = (innerHeight / 936) * 600;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        // var seaH = $(".head_div").height();
        // var countH = $(".count").height();
        // this.tableHeight = window.innerHeight - seaH - countH - 300;
        var innerHeight = window.innerHeight;
        windowX = window.innerWidth;
        this.tableHeight = (innerHeight / 936) * 600;
        console.log("this.tableHeight", this.tableHeight);
      });
    });
  },
};
</script>

<style scoped>
@import url("./css/common.css");

.filterWrap {
  min-width: 100px;
  border: 1px solid #ebeef5;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 2px 0;
  position: absolute;
  z-index: 9;
}

.editFilter {
  position: absolute;
  width: 300px;
}

.filterWrap.hideBg {
  opacity: 0;
  box-shadow: none;
}

/* .filterWrap .filterContainer {
  padding: 10px;
} */
.filterWrap .filterBottom {
  padding: 8px;
  border-top: 1px solid #ebeef5;
}

.filterWrap .filterBottom button {
  background: transparent;
  border: none;
  color: #606266;
  cursor: pointer;
  font-size: 13px;
  padding: 0 3px;
}

.filterWrap .filterBottom button.is-disabled {
  color: #c0c4cc;
  cursor: not-allowed;
}

.paginationWrap {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.filter-with-count {
  display: flex;
  align-items: center;
}

.count {
  color: #909399;
  font-size: 12px;
}

/* .el-table :deep() .el-table__fixed {
	z-index: 2006 !important;
} */
/* :deep() .action_class {
	z-index: 2006 !important;
} */

:deep() .el-table__cell {
  padding: 4px 0;
}

.count_span1 {
  /* height: 100%; */
  display: inline-block;
  vertical-align: middle;
  /* color: #409EFF; */
  /* margin: 0 auto; */
  line-height: 20px;
  white-space: nowrap;
  margin-left: 10px;
  font-size: 14px;
}

.count_span {
  /* height: 100%;	 */
  display: inline-block;
  vertical-align: middle;
  color: #409eff;
  /* margin: 0 auto; */
  line-height: 20px;
  white-space: nowrap;
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
/deep/.el-table .el-table__body-wrapper {
  transform: translateZ(0);
}
</style>
